/**
 * 是否有权限访问资金流水页面
 */
export const JOURNAL_LIST_PAGE_UUID = 'b0bd7e03-179d-4239-b2f4-a67d9aa78bcc'
